// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['navbar']

//global t function for translations
Vue.mixin({
	methods: {
		$t: function(str) {
		  return this.$store.getters['translations/t'](str)
		}
	}
})

//for translating properties
Vue.directive('translate', {
	inserted: function(el, binding, vnode) {
		el.setAttribute(binding.arg, vnode.context.$t(binding.value))
	},
	update: function(el, binding, vnode) {
		el.setAttribute(binding.arg, vnode.context.$t(binding.value))
	}
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created: function() {
	let userLang = 'en'
	if(navigator) {
		userLang = navigator.language || navigator.userLanguage;
		if(userLang.length > 2) {
			userLang = userLang.substring(0,2)
		} 
	}
	this.$store.dispatch("translations/UPDATE_TRANSLATIONS", userLang)
  },
  mounted: function() {
  }
})



// WEBPACK FOOTER //
// ./src/main.js